import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chuiz",
  "use": "icon-chuiz-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-chuiz\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<polygon points=\"17 7 17 6 8 6 8 7 12 7 12 17 8 17 8 18 17 18 17 17 13 17 13 7 17 7\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol